module.exports = __webpack_public_path__ + "media/components/country-flag/static/sb-ef25ff925956c6c7d3c3a9ce04343034.svg";